import { useRef, useState } from "react";
import { Upload, Loader2, X, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function fileUrl(path) {
  const token = localStorage.getItem("bc_token");
  return `${BACKEND}/api/files/${path}?auth=${token}`;
}

export default function ImageUpload({ label, value, onChange, testid }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.path);
      toast.success(`${label} uploaded`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div>
      <input ref={ref} type="file" accept="image/*" onChange={handle} className="hidden" data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative group rounded-xl overflow-hidden border border-slate-200">
          <img src={fileUrl(value)} alt={label} className="w-full h-40 object-cover" />
          <button
            type="button"
            data-testid={`${testid}-remove`}
            onClick={() => onChange("")}
            className="absolute top-2 right-2 h-8 w-8 rounded-full bg-black/60 text-white grid place-items-center hover:bg-[#E63946] transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          data-testid={`${testid}-btn`}
          onClick={() => ref.current?.click()}
          disabled={busy}
          className="w-full h-40 rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 hover:border-[#0B5351] hover:bg-[#0B5351]/5 grid place-items-center transition-colors"
        >
          <div className="text-center">
            {busy ? (
              <Loader2 className="h-6 w-6 animate-spin text-[#0B5351] mx-auto" />
            ) : (
              <>
                <div className="h-11 w-11 rounded-full bg-white border border-slate-200 grid place-items-center mx-auto mb-2">
                  <ImageIcon className="h-5 w-5 text-slate-400" />
                </div>
                <p className="text-sm font-medium text-slate-600 flex items-center gap-1.5 justify-center">
                  <Upload className="h-3.5 w-3.5" /> Upload {label}
                </p>
              </>
            )}
          </div>
        </button>
      )}
    </div>
  );
}
